import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const yesItems = ['Querés aprender un oficio que te dé independencia real', 'Estás cansado de un sueldo que no te alcanza', 'Necesitás un sistema concreto, no más teoría', 'Sos principiante o ya trabajás y querés mejorar'];
const noItems = ['No es para vos si buscás resultados sin aplicar nada'];
export function ForWhomSection() {
  return <section className="py-20 px-4 bg-brand-dark text-white" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-16" data-id="element-119">
          ¿Este pack es para vos?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-120">
          {/* YES */}
          <div className="bg-slate-800 p-8 md:p-10 rounded-3xl shadow-xl border-2 border-brand-green/30" data-id="element-121">
            <h3 className="text-2xl font-black text-brand-green mb-8 flex items-center gap-3" data-id="element-122">
              <span className="text-3xl" data-id="element-123">✅</span> SÍ es para vos si...
            </h3>
            <ul className="space-y-6" data-id="element-124">
              {yesItems.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-125">
                  <CheckCircleIcon className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" data-id="element-126" />
                  <span className="text-gray-200 font-medium text-lg" data-id="element-127">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* NO */}
          <div className="bg-slate-800 p-8 md:p-10 rounded-3xl shadow-xl border-2 border-red-500/30" data-id="element-128">
            <h3 className="text-2xl font-black text-red-400 mb-8 flex items-center gap-3" data-id="element-129">
              <span className="text-3xl" data-id="element-130">❌</span> NO es para vos si...
            </h3>
            <ul className="space-y-6" data-id="element-131">
              {noItems.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-132">
                  <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-133" />
                  <span className="text-gray-200 font-medium text-lg" data-id="element-134">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}